import { makeAutoObservable, runInAction } from 'mobx';
import { apiClient } from '../api/apiclient';
export class AcademyStore {
    constructor() {
        this.academies = [];
        this.loading = false;
        this.error = null;
        this.selectedAcademy = null;
        this.isDialogOpen = false;
        this.isEditing = false;
        this.currentAcademy = null;
        makeAutoObservable(this);
    }
    // Actions
    async fetchAcademies(filters) {
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.getAcademies(filters);
            if (response.success) {
                runInAction(() => {
                    this.academies = response.data;
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to fetch academies';
                this.loading = false;
            });
        }
    }
    async createAcademy(academyData) {
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.createAcademy(academyData);
            if (response.success) {
                runInAction(() => {
                    this.academies.unshift(response.data);
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to create academy';
                this.loading = false;
            });
            throw error;
        }
    }
    async updateAcademy(id, academyData) {
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.updateAcademy(id, academyData);
            if (response.success) {
                runInAction(() => {
                    const index = this.academies.findIndex(academy => academy.id === id);
                    if (index !== -1) {
                        this.academies[index] = response.data;
                    }
                    this.loading = false;
                });
                return response.data;
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to update academy';
                this.loading = false;
            });
            throw error;
        }
    }
    async deleteAcademy(id) {
        this.loading = true;
        this.error = null;
        try {
            const response = await apiClient.deleteAcademy(id);
            if (response.success) {
                runInAction(() => {
                    this.academies = this.academies.filter(academy => academy.id !== id);
                    this.loading = false;
                });
            }
            else {
                throw new Error(response.message);
            }
        }
        catch (error) {
            runInAction(() => {
                this.error = error instanceof Error ? error.message : 'Failed to delete academy';
                this.loading = false;
            });
            throw error;
        }
    }
    // Dialog actions
    openCreateDialog() {
        this.selectedAcademy = null;
        this.isEditing = false;
        this.isDialogOpen = true;
    }
    openEditDialog(academy) {
        this.selectedAcademy = academy;
        this.isEditing = true;
        this.isDialogOpen = true;
    }
    closeDialog() {
        this.isDialogOpen = false;
        this.selectedAcademy = null;
        this.isEditing = false;
    }
    // Current academy management
    setCurrentAcademy(academy) {
        this.currentAcademy = academy;
    }
    // Computed
    get hasAcademies() {
        return this.academies.length > 0;
    }
    get isLoading() {
        return this.loading;
    }
    get hasError() {
        return this.error !== null;
    }
}
export const academyStore = new AcademyStore();
